<template>
    <div
        class="connect_number"
        :style="{ backgroundColor: messenger.color }"
        @click="onClick"
    >
        <p
            class="title"
            v-text="$t(titleKey, { messenger: messenger.value })"
        />
        <img class="icon" :src="messenger?.svg"/>
        <BaseRibbonRotate
            v-if="hasRibbon"
            :text="messenger.ribbon"
            color="var(--ribbon-primary-color)"
        />
    </div>
</template>

<script setup>
// core
import {computed} from "vue";
import {useStore} from "vuex";

// components
import BaseRibbonRotate from "@/components/ui/BaseRibbonRotate.vue";

const emit = defineEmits(["onAction"])
const props = defineProps({
    messenger: {
        type: Object,
    },
    hasRibbon: {
        type: Boolean,
        default: false,
    },
    dialogFirst: {
        type: Boolean,
        default: true
    }
});


const store = useStore();

const titleKey = computed(() =>
    props.messenger?.connectAccount
        ? "general.user_bar.connect_account"
        : "general.user_bar.connect_number"
);

const onClick = () => {
    props.dialogFirst
        ? store.commit("openDialog", `AddNumber${props.messenger.title}Dialog`)
        : emit('onAction')
}
</script>

<style lang="scss" scoped>
.title {
    padding-bottom: 0;
    font-size: 12px;
    font-family: Gilroy;
    font-weight: 700;
    line-height: 15px;
    text-align: left;
    text-transform: uppercase;
    color: white;
}

.connect_number {
    position: relative;
    padding: 5px 5px 5px 18px;
    height: 55px;
    border-radius: 11px;
    display: flex;
    align-items: center;
    min-width: 160px;

    .title {
        max-width: 130px;
    }

    &:hover {
        cursor: pointer;
    }
}

.icon {
    position: relative;
    transform: inherit;
    font-size: 44px;
    height: 44px;
    color: white;
    display: flex;
    margin-bottom: 5px;
    align-items: center;
    justify-content: center;
    fill: white;

    &:before {
        font-size: 30px;
        display: flex;
        align-items: center;
        padding: 0 7px;
    }
}

.pointer {
    cursor: pointer !important;
}

@media screen and (max-width: 1200px) {
    .connect_number {
        width: 200px;
    }
}

// a cell of the header grid sets the width
@media screen and (min-width: 581px) and (max-width: 1200px) {
    .connect_number {
        width: auto;
        min-width: 0;
    }
}

@media screen and (max-width: 580px) {
    .connect_number {
        width: 100%;
        height: 45px;
        flex-direction: row-reverse;
        justify-content: flex-end;
        box-sizing: border-box;
        gap: 9px;

        .title {
            width: 100%;
        }
    }
}
</style>
